"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledChip = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _utils = require("../lib/utils");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var colors = {
  base: (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    ", "\n    ", ";\n    ", "\n  "])), function (props) {
    return !props.disabled && "background-color: ".concat(function (props) {
      return (0, _utils.getPalette)('light', 'c000')(props);
    }, ";\n      color: ").concat(function (props) {
      return (0, _utils.getPalette)('dark', 'c300')(props);
    }, ";");
  }, function (props) {
    return props.hover && "\n    &:hover {\n      background-color: ".concat((0, _utils.getPalette)('base', 'c01')(props), ";\n    }\n    ");
  }, function (props) {
    return props.disabled && "background-color: ".concat(function (props) {
      return (0, _utils.getPalette)('light', 'c100')(props);
    }, ";\n       color: ").concat(function (props) {
      return (0, _utils.getPalette)('dark', 'c100')(props);
    }, ";\n       ");
  }),
  primary: (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n    background-color: ", ";\n    color: ", ";\n    ", ";\n    ", "\n  "])), function (props) {
    return (0, _utils.getPalette)('light', 'c000')(props);
  }, function (props) {
    return (0, _utils.getPalette)('dark', 'c300')(props);
  }, function (props) {
    return props.hover && "\n      &:hover {\n        background-color: ".concat((0, _utils.getPalette)('primary', 'c05')(props), ";\n        border: 1px solid ").concat((0, _utils.getPalette)('primary', 'c01')(props), "\n      }\n      ");
  }, function (props) {
    return props.disabled && "background-color: ".concat(function (props) {
      return (0, _utils.getPalette)('light', 'c100')(props);
    }, ";\n       color: ").concat(function (props) {
      return (0, _utils.getPalette)('dark', 'c100')(props);
    }, ";");
  }),
  error: (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n    background-color: ", ";\n    color: ", ";\n  "])), function (props) {
    return (0, _utils.getPalette)('secondary', 'c00')(props);
  }, function (props) {
    return (0, _utils.getPalette)('secondary', 'c04')(props);
  }),
  custom: (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n    background-color: ", ";\n    color: ", ";\n  "])), function (props) {
    return (0, _utils.getPalette)(props.backgroundColor, props.backgroundShade)(props);
  }, function (props) {
    return (0, _utils.getPalette)(props.textColor, props.textShade)(props);
  })
};
var size = {
  small: (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])([""]))),
  medium: (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n    height: 36px;\n  "])))
};

var StyledChip = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n"])), (0, _styledComponents.css)(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n    -webkit-font-smoothing: antialiased;\n    vertical-align: middle;\n    text-align: center;\n    text-decoration: none;\n    border-radius: 40px;\n    border: 1px solid ", ";\n    display: inline-flex;\n    align-items: center;\n    box-sizing: border-box;\n    justify-content: space-between;\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n    ", "\n    ", ";\n    ", ";\n\n    ", "\n\n    .eui-chip {\n      &-avatar {\n      }\n      &-label {\n        ", "\n        ", "\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n      &-close {\n        display: inline-flex;\n        & > * {\n          display: inline-flex;\n        }\n        ", "\n        span svg {\n          path {\n            fill: ", ";\n          }\n        }\n      }\n      &-name-tag {\n        padding: 0px 8px;\n        ", "\n        color: ", ";\n      }\n      &-custom-tag {\n        padding-right: 8px;\n        display: flex;\n      }\n      ", " \n  "])), function (props) {
  return (0, _utils.getPalette)('light', 'c300')(props);
}, function (props) {
  return props.hover && "cursor: pointer;";
}, function (props) {
  return (0, _utils.isRTL)(props) && "flex-direction: row-reverse;";
}, function (props) {
  return props.radius && "\n      border-radius: ".concat(props.radius, "px;\n    ");
}, function (props) {
  return colors[props.color];
}, function (props) {
  return size[props.size];
}, _styledSystem.width, _styledSystem.space, function (props) {
  return props.disabled && " \n    span svg {\n      path {\n        fill: ".concat(function (props) {
    return (0, _utils.getPalette)('base', 'gy003')(props);
  }, ";\n      }\n    }\n    ");
}, function (props) {
  return (0, _utils.getTypography)('helperText')(props);
}, function (props) {
  return (0, _utils.isRTL)(props) ? "padding-left: ".concat(props.hasAvatar ? '16px' : '7px', ";\n          padding-right: ").concat(props.hasDelete ? '16px' : '4px', ";") : "padding-left: ".concat(props.hasAvatar ? '7px' : '16px', ";\n          padding-right: ").concat(props.hasDelete ? '4px' : '16px', ";");
}, function (props) {
  return (0, _utils.isRTL)(props) ? "padding-left: 16px;" : "padding-right: 16px;";
}, function (props) {
  return (0, _utils.getPalette)('text', 'c03')(props);
}, function (props) {
  return (0, _utils.getTypography)('helperText')(props);
}, function (props) {
  return (0, _utils.getPalette)('primary', 'c03')(props);
}, function (props) {
  return props.disabled && "\n      span svg {\n        path {\n          fill: ".concat(function (props) {
    return (0, _utils.getPalette)('base', 'gy003')(props);
  }, ";\n        }\n      }\n\n    ");
}));

exports.StyledChip = StyledChip;